/* src/app/modules/shared/components/column/column-quantity-in-stock/column-quantity-in-stock.component.scss */
app-column-quantity-in-stock {
  display: contents;
}
/*# sourceMappingURL=column-quantity-in-stock.component.css.map */
